import React from 'react'
import styled, { css } from 'styled-components'

import { useZoom } from '@sketch-hq/sketch-web-renderer'

const Grid = styled.div<{ gridSize: number; bolder?: boolean }>(
  ({ gridSize, bolder }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    pointer-events: none;

    background-image: repeating-linear-gradient(
        rgba(254, 26, 24, ${bolder ? 0.6 : 0.3}) 0 1px,
        transparent 1px 100%
      ),
      repeating-linear-gradient(
        90deg,
        rgba(254, 26, 24, ${bolder ? 0.6 : 0.3}) 0 1px,
        transparent 1px 100%
      );
    background-size: ${gridSize}px ${gridSize}px;
  `
)

type OverlayGridProps = {
  isEnabled: boolean
  gridSize: number
  thickLineStep: number
}
export const OverlayGrid = ({
  isEnabled,
  gridSize,
  thickLineStep,
}: OverlayGridProps) => {
  const zoomFactor = useZoom() ?? 1

  if (!isEnabled) {
    return null
  }

  const gridSizeAfterZoom = gridSize * zoomFactor

  return (
    <>
      <Grid gridSize={gridSizeAfterZoom * thickLineStep} bolder />
      <Grid gridSize={gridSizeAfterZoom} />
    </>
  )
}
